import React from "react";
import { PieChart } from "react-minimal-pie-chart";
import "./MyChart.css";
const Chart = (props) => {
  //   console.log("data", props);
  const root = document.documentElement;
  const rootStyles = getComputedStyle(root);
  const rootColor = rootStyles.getPropertyValue("--colorPrimary");
  // const chartMinedValue = props?.stake - props?.mined;

  const data = [
    {
      title: "Pending Funds",
      value: props?.pendingPaymentRequests,
      color: "#EFC517",
    },
    {
      title: "Approved Funds",
      value: props?.approvedPaymentRequests,
      color: "green",
    },
    {
      title: "Rejected Funds",
      value: props?.rejectedPaymentRequests,
      color: "red",
    },
  ];

  return (
    <div className="capping">
      <h3>FUNDS</h3>
      <div className="cappingGraphDiv">
        <div style={{ height: "120px" }}>
          <PieChart
            animate={true}
            animationDuration={2000}
            data={data}
            lineWidth={30}
            paddingAngle={2}
            label={({ dataEntry }) => `${Math.round(dataEntry.percentage)}%`}
            labelStyle={{
              fill: "grey",
              fontSize: "5px",
              fontFamily: "sans-serif",
              fontSize: "8px",
              fontWeight: "bold",
              borderRadius: "50%",
              backgroundColor: "red !important",
            }}
          />
        </div>
        <div className="cappingAbout ">
          <div>
            <span style={{ background: "#EFC517" }}></span>
            <p>Pending</p>
          </div>
          <div>
            <span style={{ background: "green" }}></span>
            <p>Approved</p>
          </div>
          <div>
            <span style={{ background: "red" }}></span>
            <p>Rejected</p>
          </div>
        </div>
      </div>

      <div className="cappingDetails cappingDetailsDashboard">
        <div>
          <h3>{parseFloat(props.totalPaymentRequests).toFixed(2)}</h3>
          <p>Total</p>
        </div>
        <div>
          <h3>{parseFloat(props.pendingPaymentRequests).toFixed(2)}</h3>
          <p>Pending</p>
        </div>

        <div>
          <h3>{parseFloat(props.approvedPaymentRequests).toFixed(2)}</h3>
          <p>Approved</p>
        </div>
        <div>
          <h3>{parseFloat(props.rejectedPaymentRequests).toFixed(2)}</h3>
          <p>Rejected</p>
        </div>
      </div>
    </div>
  );
};

export default Chart;
